import React from 'react';

const AppInfo = () => {
  return (
    <div className="content">
      <h1>المُطور</h1>
      <p>
        تم تطوير وتصميم التطبيق من طرف مهندس البرمجيات صلاح الدين ناصر
        <sup>
          <a
            href="https://www.facebook.com/nacersalaheddine05/"
            target="_blank"
          >
            [1]
          </a>
        </sup>
        <sub>Salah eddine, Nacer</sub>
      </p>
      <h2>التّكنُلوجيات المستخدمة</h2>
      <p>
        تطبيق القرآن عبارة عن تطبيق وييب ولتطويره تم استخدام عدة تكنلوجيات
        وادوات من
        <strong> أهمها </strong>:
      </p>
      <ul>
        <li>مكتبة الرياكت - React library 🔌</li>
        <li>مكتبة بولما - Bulma library 🔌</li>
        <li> لغة البرمجة جافاسكريبت - javascript 🔌</li>
        <li> لغة HTML و CSS للتنسيق 🔌</li>
        <li>منصة التطوير - stackblitz.io 🔌</li>
        <li>نظام ال GIT للتحكم بالنسخ 🔌</li>
      </ul>
      <h3>مُمَيزات التطبيق</h3>
      <p>
        عدة مميزات يختص بها تطبيق القرآن
        <a href="/">
          {' '}
          <em>Quran Awesome Player </em>
        </a>{' '}
        والتى تتمثل في التالي:
      </p>
      <ol>
        <li>الوضع المظلم (dark mode) 🔥</li>
        <li>البحث برقم السورة او الاسم 🔥</li>
        <li>تصميم عصري وجذاب 🔥</li>
        <li>يتوفر على عدد من القراء 🔥</li>
        <li>انشاء قائمة المفضلة 🔥</li>
        <li>
          حفض تلقائي لآخر سورة تم الاستماع لها وآخر قارئ وآخر زمن توقف 🔥
        </li>{' '}
        <li>معلومات حول السور والقراء 🔥</li>
        <li>خيار تحميل السورة 🔥</li>
      </ol>
    </div>
  );
};
export default AppInfo;
